module.exports = __webpack_public_path__ + "img/realLeaf4.0c78a0db.png";